import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clapperboard, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function AuthPage() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { signIn, signUp } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      if (mode === "signup") {
        await signUp(email, password, username);
      } else {
        await signIn(email, password);
      }
      navigate("/dashboard");
    } catch (err) {
      setError(err?.response ? apiError(err) : err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mvp-page mvp-auth-page" data-testid="auth-page">
      <div className="mvp-auth-card">
        <div className="mvp-auth-logo">
          <Clapperboard size={28} />
          <span>Anim8<em>TV</em></span>
        </div>
        <div className="mvp-auth-tabs">
          <button
            className={mode === "login" ? "active" : ""}
            onClick={() => setMode("login")}
            data-testid="auth-tab-login"
          >
            Sign In
          </button>
          <button
            className={mode === "signup" ? "active" : ""}
            onClick={() => setMode("signup")}
            data-testid="auth-tab-signup"
          >
            Create Account
          </button>
        </div>
        <form onSubmit={submit} className="mvp-auth-form">
          {mode === "signup" && (
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              minLength={2}
              data-testid="auth-username-input"
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="auth-email-input"
          />
          <input
            type="password"
            placeholder="Password (min 6 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            data-testid="auth-password-input"
          />
          {error && (
            <div className="mvp-error" data-testid="auth-error">{error}</div>
          )}
          <button type="submit" className="btn-primary mvp-auth-submit" disabled={busy} data-testid="auth-submit-btn">
            {busy ? <Loader2 size={18} className="mvp-spin" /> : mode === "login" ? "Sign In" : "Create Account"}
          </button>
        </form>
      </div>
    </div>
  );
}
